import { Record } from 'immutable';

import { MediaListEntity } from '../components/media-list/media-list.entity';

export const MediaSliceKey = 'main';

export interface IMediaOriginalSliceState {
	loading: boolean;
	list: MediaListEntity;
	deleteSuccess: boolean;
}

export const defaults: IMediaOriginalSliceState = {
	loading: false,
	list: MediaListEntity.build([]),
	deleteSuccess: false,
};

export class MediaOriginalSliceState extends Record<IMediaOriginalSliceState>(
	defaults
) {
	public static readonly key = MediaSliceKey;

	public setLoading(isLoading: boolean): MediaOriginalSliceState {
		return this.set('loading', isLoading);
	}

	public setMediaList(mediaList: MediaListEntity): MediaOriginalSliceState {
		return this.set('list', mediaList);
	}

	public setDeleteSuccess(isSuccess: boolean): MediaOriginalSliceState {
		return this.set('deleteSuccess', isSuccess);
	}
}
